// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ruMapuYfyMh2AUoUc51x{padding:0 3px}.oE4r0BSPGHWzu1azFPEG{white-space:nowrap;margin-top:-4px;text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/entities/Integrations/ui/AlertCalendlyFreePlan/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA,CAGF,sBACE,kBAAA,CACA,eAAA,CACA,oBAAA","sourcesContent":[".wrap {\n  padding: 0 3px;\n}\n\n.link {\n  white-space: nowrap;\n  margin-top: -4px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ruMapuYfyMh2AUoUc51x`,
	"link": `oE4r0BSPGHWzu1azFPEG`
};
export default ___CSS_LOADER_EXPORT___;
